<template>
  <div class="container">
    <div class="nopictures">{{ $t("no_pictures") }}</div>
  </div>
</template>

<style lang="scss">
.nopictures {
  min-height: calc(100vh - 340px);
  margin-top: 30px;

  @media (min-width: 640px) {
    min-height: calc(100vh - 290px);
  }
}
</style>
